import { emailOTPClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
  baseURL: typeof window === "undefined" ? "" : window.location.origin,
  basePath: "/api/auth",
  plugins: [emailOTPClient()],
});

export const { useSession, signOut } = authClient;
